import classnames from "classnames";
import React from "react";
import styles from "./Card.module.scss";

interface CardProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  > {
  type?: "main" | "normal";
  dir?: "ltr" | "rtl";
}

const Card = ({
  children,
  className,
  style,
  type = "normal",
  ...rest
}: CardProps) => (
  <article
    className={classnames(styles.card, styles[type], className)}
    {...rest}
  >
    {children}
  </article>
);

export default Card;
